import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AppStateService } from '../app-state.service';
import { Patient } from '../registration/patient.model';
import { FormConfigService } from '../registration/forms-config.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-patients-list',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './patients-list.component.html',
  styleUrls: ['./patients-list.component.scss']
})
export class PatientsListComponent implements OnInit {
  familyPatients: Patient[] = [];
  selectedPatient?: Patient;
  clientId: string = '';
  isFamilyListLoading = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private appStateService: AppStateService,
    private formConfigService: FormConfigService
  ) {
    // Retrieve any previously selected patient
    this.selectedPatient = this.appStateService.getState().patient;
    this.clientId = this.appStateService.getState().clientId || '';
  }

  ngOnInit(): void {
    // Start the spinner before calling the lookup
    this.isFamilyListLoading = true;

    // Subscribe to state changes to wait for patient data to be available
    this.appStateService.state$.subscribe(state => {
      // Update selectedPatient when state changes
      if (state.patient && state.patient.phoneNumber && !this.selectedPatient?.phoneNumber) {
        this.selectedPatient = state.patient;
        this.performFamilyLookup();
      }
    });

    // If patient data is already available, perform lookup immediately
    if (this.selectedPatient?.phoneNumber) {
      this.performFamilyLookup();
    }
  }

  private performFamilyLookup(): void {
    if (!this.selectedPatient?.phoneNumber) {
      this.isFamilyListLoading = false;
      return;
    }

    this.formConfigService.fetchPatientFamilyLookup(this.clientId, {
      orgId: this.appStateService.getState().orgId,
      clientId: this.clientId,
      phoneNumber: this.selectedPatient.phoneNumber,
    }).subscribe({
      next: (response: any) => {
        if (response && response.length > 0) {
          // Update the shared state with the family lookup response
          this.appStateService.updateFamilyLookupResponse(response);
          this.familyPatients = response;
        } else {
          this.familyPatients = [];
        }
        // Stop the spinner after processing the response
        this.isFamilyListLoading = false;
      },
      error: () => {
        // Stop the spinner on error as well
        this.isFamilyListLoading = false;
      }
    });
  }

  getInitials(firstName: string, lastName: string): string {
    if (!firstName || !lastName) return '';
    return (firstName[0] + lastName[0]).toUpperCase();
  }

  onSelectPatient(patient: any): void {
    patient['patientId'] = patient['id'];
    this.appStateService.setState({ patient });
    this.appStateService.setState({
      patientId: patient['id'],
    });
    // Update the local property so the UI can highlight the selection
    this.selectedPatient = patient;
    // Navigate to the patient dashboard or wherever needed
    this.router.navigate(['/dashboard/main']);
  }
}